export default {
    methods: {
        showSuccessMsg(msg) {
            this.$swal.fire({
                position: 'top-right',
                icon: 'success',
                toast: true,
                title: msg,
                showConfirmButton: false,
                timer: 1500
            })
        },
        showFailMsg(msg) {
            this.$swal.fire({
                position: 'top-right',
                icon: 'error',
                toast: true,
                title: msg,
                showConfirmButton: false,
                timer: 1500
            })
        },
        sameHeight(value = null) {
            var left_length = window.$("#video_wrap").length;

            let left = 0
            if (left_length > 0) {
                left = document.getElementById('v_wrap').getBoundingClientRect().height;
                left = left - value;
            }
            if (left_length > 0) {
                document.getElementById('chat_wrap').style.height=left + 'px';
                document.getElementById('plist_wrap').style.height=left + 'px';
            }
        },
        pinnedPost() {
            let pinnedPostHeight = window.$('.pinned_post_wrapper').outerHeight();
            let replyChatHeight = window.$('.reply_chat').outerHeight();
            if (pinnedPostHeight === undefined)
                pinnedPostHeight = 0
            if (replyChatHeight === undefined)
                replyChatHeight = 0

            window.$('.chat_head').css({
                top : `${pinnedPostHeight}px`,
                height: `calc(100% - ${pinnedPostHeight + replyChatHeight}px)`
            })
        },
        collapseArrow() {
            let self = this;

            window.$('.collapse_arrow span').click(function () {
                window.$('#wrapper').removeClass('right_menu_collapse');
                window.$('#wrapper').toggleClass('vertical_collpsed');
                window.$('.mobile_overlay').toggleClass('open');

                if (window.$('#wrapper').hasClass('vertical_collpsed')) {
                    self.hideOtherNav('.left_nav_list > li', '.left_f_list');
                    self.hideOtherNav('.left_nav_level2', '.left_f_list_level2');
                    self.hideOtherNav('.left_nav_level3', '.left_f_list_level3');
                }

                setTimeout(() => {
                    self.sameHeight ()
                }, 490);
            });
        },
        hideOtherNav(selector = '.left_nav_list > li', finderSelector = '.left_f_list') {
            let list = window.$(selector);

            for (let index = 0; index < list.length; index++) {
                const element = list[index];
                let elementId = window.$(element).find(finderSelector).data('target');
                window.$(window.$(element).find(finderSelector).removeClass('open'));
                window.$(elementId).hide();
            }
        },
        checkPermission(module) {
            let permission = this.$store.getters['auth/getPermissions']
            if(permission  && permission.length){
                let find = permission.find(item => item.module === module)
                if(find){
                    return true
                } else {
                    return false
                }
            }
        },
        getTitle(file){
            if(file && typeof file === 'string') {
                let item = file.split("/") ? file.split("/") : null;

                if (item)
                    return item.pop();
            }
        }
    }
}